import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Roles } from '@edtech-ui/constants/roles.enum';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../authService/auth-service.service';

@Injectable({
	providedIn: 'root'
})
export class AuthRedirectService {

	constructor(
		private router: Router,
		private _toastr: ToastrService,
		private _authService: AuthServiceService,
	) { }

	handlePostLoginRedirect(redirectUrl?: string | null) {
		if (redirectUrl) {
			let target = redirectUrl;
			try {
				while (target.includes('%2F') || target.includes('%3F') || target.includes('%3D') || target.includes('%26')) {
					target = decodeURIComponent(target);
				}
			} catch (e) {
				// in case decodeURIComponent throws URIError on malformed sequences
			}

			if (target.startsWith(window.location.origin)) {
				target = target.substring(window.location.origin.length);
			}

			if (target.includes('/interview.ai/')) {
				const fullTargetUrl = target.startsWith('http') ? target : `${window.location.origin}${target.startsWith('/') ? '' : '/'}${target}`;
				window.open(fullTargetUrl, '_blank');
				this.router.navigate(['/student-dashboard']);
				return;
			}
			this.router.navigateByUrl(target);
			return;
		}

		// First, check allowed route from user's permissions and modules
		const allowedRoute = this._authService.getFirstAllowedRoute();
		if (allowedRoute && allowedRoute !== '/access-denied' && allowedRoute !== '/access_denied') {
			this.router.navigateByUrl(allowedRoute);
			return;
		}

		// Fall back to role-based navigation
		const roleId = Number(localStorage.getItem('role_id'));
		switch (roleId) {
			case Roles.TEACHER:
				this.router.navigate(['/teacher-dashboard']);
				break;
			case Roles.STUDENT:
				this.router.navigate(['/student-dashboard']);
				break;
			case Roles.ADMIN:
				this.router.navigate(['/admin-dashboard']);
				break;
			case Roles.StudentPlatformAdmin:
				this.router.navigate(['/admin-student-platform']);
				break;
			case Roles.MENTOR:
				this.router.navigate(['/mentor-panel']);
				break;
			case Roles.COMPANYADMIN:
			case Roles.COMPANY_EDUCATOR_ADMIN:
				this.router.navigate(['/recruiter-landing']);
				break;
			default:
				if (allowedRoute && allowedRoute !== '/access-denied' && allowedRoute !== '/access_denied') {
					this.router.navigateByUrl(allowedRoute);
				} else {
					this.router.navigate(['/student-dashboard']);
				}
		}
	}

	redirectIfLoggedIn(redirectUrl?: string | null) {
		const token = localStorage.getItem('token');
		const roleId = Number(localStorage.getItem('role_id'));

		if (token && roleId) {
			this.handlePostLoginRedirect(redirectUrl);
		}
	}
}
